import { z } from 'zod';

export const QuarkExperienceTypes = z.object({
  id: z.string().uuid(),
  name: z.string(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type QuarkExperienceTypesT = z.infer<typeof QuarkExperienceTypes>;

export const QuarkExperienceTypesInsert = QuarkExperienceTypes.partial();

export type QuarkExperienceTypesInsertT = z.infer<
  typeof QuarkExperienceTypesInsert
>;

export const QuarkExperienceTypesUpdate = QuarkExperienceTypes.partial();

export type QuarkExperienceTypesUpdateT = z.infer<
  typeof QuarkExperienceTypesUpdate
>;
